export default {
  placeholder: 'Inserisci il nome del ristorante',
  labels: {
    cant_find_place: "Non riesci a trovare il luogo nell'elenco?",
    reset_categories: 'Reimposta le categorie del luogo',
  },
};
